//@flow
import React from 'react';
import AccessibleButtonWrapper from './AccessibleButtonWrapper.react';

type Props = {
  expanded:boolean,
  className?:string,
  action:()=>void,
  moreLabel?:string,
  lessLabel?:string,
  reversed?:boolean,
};

function getCollapsedArrow(reversed:?boolean):string {
  if (reversed) return 'up-arrow-component';
  return 'down-arrow-component';
}

function getExpandedArrow(reversed:?boolean):string {
  if (reversed) return 'down-arrow-component';
  return 'up-arrow-component';
}

export default function IconExpandArrow(props:Props) {
  const { action, expanded, reversed } = props;
  const lessLabel = props.lessLabel || 'Less information';
  const moreLabel = props.moreLabel || 'More information';
  const className = props.className || '';
  if (expanded) {
    return (
      <AccessibleButtonWrapper
        className={`arrow ${getExpandedArrow(reversed)} ${className}`}
        label={lessLabel}
        action={action}
      />
    );
  }
  return (
    <AccessibleButtonWrapper
      className={`arrow ${getCollapsedArrow(reversed)} ${className}`}
      label={moreLabel}
      action={action}
    />
  );
}
